import React from 'react';
import SourceBadge from './SourceBadge';
import './RAGAnalysis.css';

const RootCauseSection = ({ rootCause, source }) => {
    if (!rootCause) return null;

    return (
        <div className="rag-section root-cause-section">
            <div className="rag-section-header">
                <h4 className="rag-section-title">Root Cause</h4>
                <SourceBadge source={source} />
            </div>
            <p className="rag-section-body">{rootCause}</p>
        </div>
    );
};

export default RootCauseSection;
